import { Box, Typography } from '@mui/material';
import { LayoutType } from 'model/deals.model';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import SectionLoader from 'components/shared/SectionLoader';
import { Filters } from './Filters';
import Grid from './Grid';
import { muiStyles } from './muiStyles';
import Table from './Table';
import { useContacts } from './useContacts';

const BusinessesMain = () => {
  const { id } = useParams();
  const {
    data,
    loading,
    totalCount,
    totalPages,
    currentPage,
    handlePageChange,
    handleRowsChange,
    limit,
    value,
    debouncedValue,
    handleChange,
    clearInput,
    fetchContacts,
  } = useContacts(id ?? '');

  const [layout, setLayout] = useState<LayoutType>(LayoutType.KANBAN);

  const handleLayoutChange = (_: SyntheticEvent, newValue: LayoutType) => {
    setLayout(newValue);
  };

  useEffect(() => {}, []);

  if (loading || !data) return <SectionLoader />;

  const Content = layout === LayoutType.KANBAN ? Grid : Table;

  return (
    <Box sx={muiStyles.container}>
      <Box sx={muiStyles.header}>
        <Typography variant='responsiveHeading3'>Contacts</Typography>
        <Filters
          layout={layout}
          onLayoutChange={handleLayoutChange}
          value={value}
          debouncedValue={debouncedValue}
          handleChange={handleChange}
          clearInput={clearInput}
        />
      </Box>
      <Content
        contacts={data.contacts}
        totalCount={totalCount}
        totalPages={totalPages}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        handleRowsChange={handleRowsChange}
        limit={limit}
        fetchContacts={fetchContacts}
      />
    </Box>
  );
};

export default BusinessesMain;
